module.exports = __webpack_public_path__ + "img/muglo-currency-guide-1.6ba2b7fe.png";